import { PrintType } from '@/types';

export const getPrintColor = (printType: PrintType, id: string) =>
  printType.colors.find((color) => color.id === id);

export const getPrintColorByFill = (printType: PrintType, fill: string) =>
  printType.colors.find((c) => c.fill === fill);
